<div
    *ngIf="(uiVersion.canTryNext$ | async) && !dismissed"
    class="new-ui-banner"
>
    <nb-icon icon="fa-rocket" class="new-ui-banner-icon"></nb-icon>
    <span class="new-ui-banner-text">{{ 'ui-version.banner' | translate }}</span>
    <button nbButton size="small" status="primary" (click)="uiVersion.switchTo('next')">
        {{ 'ui-version.try-next' | translate }}
    </button>
    <button nbButton ghost size="small" (click)="dismiss()">
        {{ 'ui-version.later' | translate }}
    </button>
</div>
